import { addJPushNotificationListener, type JPushNotificationData } from '@/lib/jpush'
import { router, type Href } from 'expo-router'
import { useEffect } from 'react'
import { Linking, Platform } from 'react-native'

// A component to listen to JPush notifications for both notificationArrived and
// notificationOpened events. Badge sync is handled elsewhere via JPush.setBadge.

// iOS 的通知点击深链跳转由原生处理（plugins/withJpush.js 注入的 AppDelegate 读取
// userInfo["deeplink"]）；Android 无对应原生处理，需在 JS 侧读取 extras.deeplink 跳转。
function handleDeepLink(deeplink?: string) {
  if (!deeplink) return

  if (deeplink.includes('://')) {
    Linking.openURL(deeplink).catch(err => console.warn('[JPushNotificationListener] openURL 失败:', err))
    return
  }

  const path = deeplink.startsWith('/') ? deeplink : `/${deeplink}`
  router.push(path as Href)
}

export default function JPushNotificationListener() {
  useEffect(() => {
    const cleanup = addJPushNotificationListener((notification: JPushNotificationData) => {
      console.log('[JPushNotificationListener] 收到通知:', notification.notificationEventType, notification.extras)

      if (Platform.OS === 'android' && notification.notificationEventType === 'notificationOpened') {
        handleDeepLink(notification.extras?.deeplink)
      }
    })
    return cleanup
  }, [])

  return null
}
